// src/constants/quickFindCategories.js
// One palette for the three surfaces of a quick find: the button that starts
// it (MapControls), the overlay that runs while it works (FindLoadingOverlay),
// and the accent rail on the result rows (CapsuleClusterModal). These used to
// be three copies, and eat/drink had drifted — a user tapped an orange button,
// watched an orange overlay, then got results railed in a different orange.
// The MapControls values are canonical: they are what a user sees first.
export const QUICK_FIND_CATEGORY_COLORS = {
  eat: "#FF6B4A",
  drink: "#00A7C7",
  fun: "#5B4BFF",
};
